import React, { Component } from 'react';
import _, { isEmpty, get } from 'lodash';
import routes from "../../../../../../routes";
import { handleFieldError, initializeForm, handleError } from "../../../../../../utils/form-validation";
import { formFields } from "./constant";
import { connect } from 'react-redux';
import Input from '../../../../../../components/FormElements/Input';

class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {},
      touched: {},
      errors: {},
      form: {},
      touched: {},
      errors: {},
      editMode: false,
      submited: false,
      gam360Ads: [{ gamAccountID: "", gamCurrency: "", errors: {}, touched: {} }],
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.checkFields != "") {
      this.checkFormFields();
    }
  }

  componentWillMount() {
    let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
    if (isEmpty(isAuthenticated)) {
      const { history } = this.props;
      history.push(routes.preSignIn);
    }
    const { form, errors } = initializeForm(formFields);

    this.setState({ form, errors }, () => {
      this.editId();
    });
  }

  handleChange = (e, index) => {
    let { form, gam360Ads } = this.state;
    const { handleCallback } = this.props;
    let { value, name } = e.target;
    form[name] = value;
    this.setState({ form });

    const list = [...gam360Ads];
    list[index][name] = value;
    this.setState({ gam360Ads: list });

    var obj = "";
    gam360Ads.forEach((item => {
      obj = !Object.values(item).some((x) => x == "")
    }))

    if (obj) {
      handleCallback(gam360Ads);
    }
  }

  handleTouch = (e, index) => {
    let { gam360Ads } = this.state;
    let { error } = handleFieldError(gam360Ads[index][e.target.name], formFields[e.target.name]);
    gam360Ads[index].errors[e.target.name] = error;
    gam360Ads[index].touched[e.target.name] = true;
    this.setState({ gam360Ads });
  };

  // ========== google ads start =============
  handleRemoveClick = index => {
    const list = [...this.state.gam360Ads];
    list.splice(index, 1);
    this.setState({ gam360Ads: list });
  };

  handleAddClick = () => {
    this.setState({ gam360Ads: [...this.state.gam360Ads, { gamAccountID: "", gamCurrency: "", errors: {}, touched: {} }] });
  };

  renderGamValue = () => {
    let gam360Ads = this.state.gam360Ads;
    const { confirmationOpen, confirmationInfo, submited, errors, touched, form, editMode } = this.state;
    let gam360AdsValue = gam360Ads.map((gamAdsList, index) => {
      return (
        <div className='ml-5'>
          <h5>Gam Account {index + 1} :</h5>

          <div className='ml-5'>
            <Input
              onChange={(e) => this.handleChange(e, index)}
              onBlur={(e) => this.handleTouch(e, index)}
              value={gamAdsList.gamAccountID}
              setting={formFields[formFields.gamAccountID.key]}
              error={gamAdsList.errors[formFields.gamAccountID.key]}
              submited={submited}
              touched={gamAdsList.touched[formFields.gamAccountID.key]}
            />
          </div>
          <div className='ml-5 removeML'>
            <Input
              onChange={(e) => this.handleChange(e, index)}
              onBlur={(e) => this.handleTouch(e, index)}
              value={gamAdsList.gamCurrency}
              setting={formFields[formFields.gamCurrency.key]}
              error={gamAdsList.errors[formFields.gamCurrency.key]}
              submited={submited}
              touched={gamAdsList.touched[formFields.gamCurrency.key]}
            />
            <button className="btn-remove-io" onClick={() => this.handleRemoveClick(index)}><i className='mdi mdi-delete'></i></button>
          </div>
        </div>
      )
    })
    return gam360AdsValue;
  };

  checkFormFields = () => {
    const { checkFields, handleCallback } = this.props;
    const { errors, gam360Ads } = this.state;
    var gamCheck = this.handleGamError();
    if (gamCheck) {
      handleCallback(gam360Ads);
    }
    this.setState({ errors: errors, submited: true });
  }

  handleGamError = () => {
    const { gam360Ads } = this.state;
    let gamCheck = true;

    gam360Ads.forEach((item) => {
      const { errors, valid } = handleError(item, formFields);
      item.errors = errors;
      if (!gamCheck || !valid) {
        gamCheck = false;
      } else if (gamCheck && valid) {
        gamCheck = true;
      }
    });

    this.setState({ gam360Ads });
    return gamCheck;
  }

  // ====== edit by id =====
  editId = () => {
    const { dvEditData, props: { match: { params: { id } } }, handleCallback } = this.props;
    const { gam360Ads } = this.state;

    if (id) {
      let gamAdsData = dvEditData.map(item => {
        return { gamAccountID: item.accountId, gamCurrency: item.currency, errors: {}, touched: {} }
      })
      this.setState({ gam360Ads: gamAdsData }, () => {
        handleCallback(gam360Ads)
      })
    }
  }

  render() {
    return (
      <>
        <div className='main-class-wrap text-left'>
          <this.renderGamValue />
          <button className='btn-add-io' onClick={() => this.handleAddClick(index)}><i className="mdi mdi-plus"></i> Add Google Platform</button>
        </div>
      </>
    );
  }
}

export default connect(
  state => ({})
)(index);